<template>
  <el-row v-loading.fullscreen.lock="base.loading" class="page_el_container">
    <el-container class="banner-section">
      <div class="page-container">
        <el-row :gutter="10" class="vertical-align-center full-width">
          <!--how can we help(left)-->
          <el-col :lg="14" :md="24" :sm="14" :xs="24" class="banner-content-top">
            <h1 class="banner-title">{{ $t('login.howCanIHelp') }}</h1>
            <p class="banner-description">{{ $t('login.homePageMsg') }}</p>
            <el-row class="m-t-20">
              <el-col :lg="24" :md="24" :sm="24" :xs="24">
                <el-row class="select-course">
                  <el-input
                    v-model="base.searchQuery"
                    :placeholder="$t('search')"
                    clearable
                    @change="search"
                    @input="handleSearchHelpContent"
                    @keyup.enter="handleSearchHelpContent"
                  ></el-input>
                  <el-card v-if="base.isSearch && !base.isLoaded" v-click-away="clickedAway">
                    <div class="results-dropdown wrap-scrollbar">
                      <div
                        v-for="content in base.searchHelpContents"
                        :key="content._id"
                        class="results-list-Itemsrow"
                      >
                        <slot name="item" :item="content">
                          <el-link @click="handleHelpContentSearchClick(content)">
                            {{ getSystemPageName(content.context.systemPageName) }} >
                            <highlighter
                              :search-words="[base.searchQuery.trim()]"
                              :text-to-highlight="content.displayName"
                            />
                          </el-link>
                        </slot>
                      </div>
                    </div>
                  </el-card>
                  <el-card
                    v-if="base.isSearch && base.searchHelpContents.length === 0"
                    v-click-away="clickedAway"
                  >
                    <div class="results-dropdown wrap-scrollbar">
                      <div class="results-list-Itemsrow p-t-15 p-b-15">
                        <span>{{ $t('helpDocs.noResultsFound') }}</span>
                      </div>
                    </div>
                  </el-card>
                  <el-card
                    v-if="base.isLoaded && base.searchHelpContents.length === 0"
                    v-click-away="clickedAway"
                  >
                    <div class="results-dropdown wrap-scrollbar">
                      <div class="results-list-Itemsrow p-t-15 p-b-15">
                        <span>{{ $t('helpDocs.searching') }}</span>
                      </div>
                    </div>
                  </el-card>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
          <!--how can we help(left)-->
          <!--how can we help(right)-->
          <el-col :lg="10" :md="24" :sm="10" :xs="24" class="help-right-content">
            <el-col class="worflow-managemant-card light-blue-bg">
              <el-card shadow="never">
                <p>{{ $t('login.gainTechSkills') }}</p>
              </el-card>
            </el-col>
            <el-col class="worflow-managemant-card saffron-bg">
              <el-card shadow="never">
                <p>{{ $t('login.resourceLib') }}</p>
              </el-card>
            </el-col>
            <el-col class="worflow-managemant-card blue-bg">
              <el-card shadow="never">
                <p>{{ $t('login.learnExp') }}</p>
              </el-card>
            </el-col>
          </el-col>
          <!--how can we help(right)-->
        </el-row>
      </div>
    </el-container>
    <el-container class="explore-product-section">
      <div class="page-container">
        <el-row :gutter="40" type="flex" justify="center" class="tc exploreProductListItem">
          <!--Explore-product-section-->
          <el-col
            :lg="chatbotStore.isOpen ? 24 : 4"
            :md="chatbotStore.isOpen ? 24 : 24"
            :sm="chatbotStore.isOpen ? 24 : 24"
            :xs="24"
          >
            <h2>{{ $t('login.exploreProduct') }}</h2>
          </el-col>
          <el-col
            :lg="chatbotStore.isOpen ? 6 : 4"
            :md="chatbotStore.isOpen ? 12 : 6"
            :sm="chatbotStore.isOpen ? 12 : 6"
            :xs="24"
            class="product-card"
          >
            <el-card
              class="cursor-pointer"
              tabindex="0"
              @click="handleProductCard('/gettingStartedETP')"
            >
              <img
                src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/svg/etrack-logo.svg"
                alt=""
              />
            </el-card>
          </el-col>
          <el-col
            :lg="chatbotStore.isOpen ? 6 : 4"
            :md="chatbotStore.isOpen ? 12 : 6"
            :sm="chatbotStore.isOpen ? 12 : 6"
            :xs="24"
            class="product-card"
          >
            <el-card
              class="cursor-pointer"
              tabindex="0"
              @click="handleProductCard('/EtrmVideoTutorials')"
            >
              <img
                src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/svg/eTRM.svg"
                alt=""
              />
            </el-card>
          </el-col>
          <el-col
            :lg="chatbotStore.isOpen ? 6 : 4"
            :md="chatbotStore.isOpen ? 12 : 6"
            :sm="chatbotStore.isOpen ? 12 : 6"
            :xs="24"
            class="product-card"
          >
            <el-card
              class="cursor-pointer"
              tabindex="0"
              @click="handleProductCard('/gettingStartedDRM')"
            >
              <img
                src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/svg/drm.svg"
                alt=""
              />
            </el-card>
          </el-col>
          <el-col
            :lg="chatbotStore.isOpen ? 6 : 4"
            :md="chatbotStore.isOpen ? 12 : 6"
            :sm="chatbotStore.isOpen ? 12 : 6"
            :xs="24"
            class="product-card"
          >
            <el-card class="disabled_btn" tabindex="0">
              <img
                src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/svg/ZAPture.svg"
                alt=""
                class="zapture-logo"
              />
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-container>
    <el-container class="Popular-articles">
      <el-row class="page-container">
        <el-col :span="24">
          <h2>
            {{ $t('login.articles') }}
            <i class="fal fa-long-arrow-right" aria-hidden="true"></i>
          </h2>
        </el-col>
        <el-col :span="24">
          <el-row :gutter="20" class="m-b-10">
            <!--Explore-product-section-->
            <el-col
              :md="chatbotStore.isOpen ? 8 : 4"
              :sm="8"
              :xs="24"
              class="arictles-card disabled_btn"
            >
              <el-card>
                <el-row class="card-img">
                  <img
                    src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/webp/envelope.webp"
                    alt=""
                  />
                </el-row>
                <p>{{ $t('login.news') }}</p>
                <el-button text class="view-all-btn">
                  {{ $t('login.viewAll') }}
                  <i class="fal fa-long-arrow-right" aria-hidden="true"></i>
                </el-button>
              </el-card>
            </el-col>
            <el-col
              :md="chatbotStore.isOpen ? 8 : 4"
              :sm="8"
              :xs="24"
              class="arictles-card disabled_btn"
            >
              <el-card>
                <el-row class="card-img">
                  <img
                    src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/webp/renewable-energy.webp"
                    alt=""
                  />
                </el-row>
                <p>{{ $t('login.distEnRes') }}</p>
                <el-button text class="view-all-btn">
                  {{ $t('login.viewAll') }}
                  <i class="fal fa-long-arrow-right" aria-hidden="true"></i>
                </el-button>
              </el-card>
            </el-col>
            <el-col
              :md="chatbotStore.isOpen ? 8 : 4"
              :sm="8"
              :xs="24"
              class="arictles-card disabled_btn"
            >
              <el-card>
                <el-row class="card-img">
                  <img
                    src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/webp/energy.webp"
                    alt=""
                  />
                </el-row>
                <p>{{ $t('login.efficiency') }}</p>
                <el-button text class="view-all-btn">
                  {{ $t('login.viewAll') }}
                  <i class="fal fa-long-arrow-right" aria-hidden="true"></i>
                </el-button>
              </el-card>
            </el-col>
            <el-col :md="chatbotStore.isOpen ? 8 : 4" :sm="8" :xs="24" class="arictles-card">
              <el-card>
                <el-row class="card-img">
                  <img
                    src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/webp/data-analytics.webp"
                    alt=""
                  />
                </el-row>
                <p>{{ $t('login.results') }}</p>
                <a href="javascript:;" target="_blank" rel="noopener" class="view-all-btn">
                  {{ $t('login.viewAll') }}
                  <i class="fal fa-long-arrow-right" aria-hidden="true"></i>
                </a>
              </el-card>
            </el-col>
            <el-col
              :md="chatbotStore.isOpen ? 8 : 4"
              :sm="8"
              :xs="24"
              class="arictles-card disabled_btn"
            >
              <el-card>
                <el-row class="card-img">
                  <img
                    src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/webp/ESG.webp"
                    height="53"
                    alt=""
                  />
                </el-row>
                <p>{{ $t('login.envSocGov') }}</p>
                <el-button text class="view-all-btn">
                  {{ $t('login.viewAll') }}
                  <i class="fal fa-long-arrow-right" aria-hidden="true"></i>
                </el-button>
              </el-card>
            </el-col>
            <el-col
              :md="chatbotStore.isOpen ? 8 : 4"
              :sm="8"
              :xs="24"
              class="arictles-card disabled_btn"
            >
              <el-card>
                <el-row class="card-img">
                  <img
                    src="https://cdn.anbetrack.com/anbsystems/anb-learning-center/webp/electric-car.webp"
                    alt=""
                  />
                </el-row>
                <p>{{ $t('login.elecVehicle') }}</p>
                <el-button text class="view-all-btn">
                  {{ $t('login.viewAll') }}
                  <i class="fal fa-long-arrow-right" aria-hidden="true"></i>
                </el-button>
              </el-card>
            </el-col>
            <!--Explore-product-section-->
          </el-row>
        </el-col>
      </el-row>
    </el-container>
  </el-row>
</template>

<script>
import { reactive, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { directive } from 'vue3-click-away'
import Highlighter from 'vue-highlight-words'
import _ from 'lodash'
import { useI18n } from 'vue-i18n'
import CommonJS from '../utilis/common'
import Constants from '@/constants'
import HelpContentsSvc from '@/middleware/helpContents'
import { useChatbotStore } from '@/stores/chatbot'
import { useRuntimeConfig } from '#imports'

export default {
  name: 'LoginComponent',
  components: {
    Highlighter
  },
  directives: {
    clickAway: directive
  },
  setup() {
    const baseApiUrl = useRuntimeConfig()
    const router = useRouter()
    const { t } = useI18n()
    const chatbotStore = useChatbotStore()
    const base = reactive({
      loading: false,
      searchQuery: '',
      isSearch: false,
      isLoaded: false,
      searchHelpContents: []
    })

    onBeforeUnmount(() => {
      base.searchQuery = null
      base.searchHelpContents.length = 0
    })

    const handleProductCard = route => {
      router.push(route)
    }

    const search = () => {
      if (!base.searchQuery) {
        base.isSearch = false
        base.searchHelpContents = []
      }
    }

    const getSystemPageName = name => {
      return CommonJS.getSystemPageName(name, t)
    }

    const clickedAway = () => {
      base.isSearch = false
      base.searchHelpContents = []
    }

    const handleHelpContentSearchClick = value => {
      const name = value?.context?.systemPageName ?? ''
      if (name) {
        base.isSearch = false
        base.searchQuery = ''
        base.searchHelpContents = []
        const query = { name, id: value._id }
        if (name === Constants.CONT_BASIC_COURSES) {
          router.push({ path: '/BasicTrainingCourses', query })
        } else if (name === Constants.CONT_ADVANCED_COURSES) {
          router.push({ path: '/AdvancedConfigurationCourses', query })
        } else if (name === Constants.TROUBLESHOOTING) {
          router.push({ path: '/EtpTroubleshooting', query })
        } else if (name === Constants.CONT_INTERMEDIATE_CONFIGURATION_COURSE) {
          router.push({ path: '/IntermediateConfigurationCourses', query })
        } else if (name === Constants.CONT_BASIC_PROFICIENCY) {
          router.push({ path: '/BasicProficiencyCourses', query })
        } else if (name === Constants.CONT_BASIC_CONFIGURATION_COURSE) {
          router.push({ path: '/BasicConfigurationCourses', query })
        } else if (name === Constants.CONT_INTERMEDIATE_PROFICIENCY) {
          router.push({ path: '/IntermediateProficiencyCourses', query })
        } else {
          router.push({ path: '/HelpDocs', query })
        }
      }
    }

    const getQuery = (query, fields) => {
      return {
        query,
        fields,
        entityType: Constants.SYSTEM_PAGE,
        page: Constants.CURRENT_PAGE,
        limit: Constants.MAX_PER_PAGE
      }
    }
    const handleSearchHelpContent = _.debounce(() => {
      if (base.searchQuery.length > 2) {
        base.searchHelpContents = []
        base.isSearch = true
        const query = {
          'products.code': Constants.ETP_PRODUCT,
          displayName: { $regex: base.searchQuery.trim(), $options: 'i' }
        }
        base.isLoaded = true
        HelpContentsSvc.findByEntityType(
          getQuery(query, Constants.HELP_CONTENTS_SEARCH_FIELDS),
          baseApiUrl
        )
          .then(result => {
            base.searchHelpContents = result?.data?.records ?? []
            base.searchHelpContents = base.searchHelpContents.filter(h =>
              Constants.SYSTEM_PAGE_NAME.includes(h.context.systemPageName)
            )
            base.searchHelpContents = _.orderBy(base.searchHelpContents, ['order'], ['asc'])
            base.isLoaded = false
          })
          .catch(error => {
            base.isLoaded = false
            base.isSearch = false
            console.log('Error in fetching help contents', error)
          })
      } else {
        base.isSearch = false
        base.searchHelpContents = []
      }
    }, 500)

    const handleComingSoon = () => {
      router.push('/ComingSoon')
    }

    return {
      base,
      handleProductCard,
      clickedAway,
      search,
      getSystemPageName,
      handleHelpContentSearchClick,
      handleSearchHelpContent,
      handleComingSoon,
      chatbotStore
    }
  }
}
</script>
